import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Swal from 'sweetalert2'
import { BiEdit, BiTrash } from 'react-icons/bi'
import { getFAQS, deleteFAQS, updateFAQ } from 'services/faq'
import { useHistory, Link } from 'react-router-dom'
import FAQ from 'models/faq'
import BreadCrumb from 'components/BreadCrumb'
import { DefaultPageTitle } from 'components/DefaultPageTitle'
import CreateButtonDefaultContainer from 'components/CreateButtonDefaultContainer'
import DefaultButton from 'components/DefaultButton'
import DefaultTable from 'components/DefaultTable'
import { formatDate } from 'helpers/format-date'
import { AiOutlineDown, AiOutlineUp } from 'react-icons/ai'

import { FAQContainer } from './style'

const FAQS: React.FC = () => {
	const history = useHistory()
	const [faqs, setFaqs] = useState<Array<FAQ>>()
	const [editFaq, setEditFaq] = useState<boolean>(false);

	const getFaqsInfo = async () => {
		const localFaqs = await getFAQS()

		setFaqs(localFaqs)
	}

	useEffect(() => {
		getFaqsInfo()
	}, [])

	const editFAQS = useCallback(
		(faqId: string) => {
			history.push(`edit-faqs/${faqId}`)
		},
		[history]
	)

	const createFAQS = () => {
		history.push('create-faqs')
	}

	const deleteFAQ = useCallback(async (faqId: string) => {
		Swal.fire({
			title: '<strong>Confirmação</strong>',
			html: 'Tem certeza que deseja remover este FAQ?',
			showCancelButton: true,
			cancelButtonText: 'Cancelar',
			focusConfirm: false,
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					await deleteFAQS(faqId)

					Swal.fire({
						icon: 'success',
						title: 'Sucesso!',
						text: 'FAQ excluida com sucesso!',
					})

					await getFaqsInfo()
				} catch (error: any) {
					Swal.fire({
						icon: 'error',
						title: 'Erro',
						text: `Erro ao excluir FAQ. ${error.message}`,
					})
				}
			}
		})
	}, [])

	const reorderFAQs = async (faq: any, up: boolean) => {
		if (faqs) {
			setEditFaq(true)
			const localFaqs = [...faqs]
			const indexOfFaq = faqs.indexOf(faq)
			if (indexOfFaq > -1 && indexOfFaq < localFaqs.length) {
				localFaqs.splice(indexOfFaq, 1)
				if (up) {
					localFaqs.splice(indexOfFaq - 1, 0, faq)
				} else {
					localFaqs.splice(indexOfFaq + 1, 0, faq)
				}
			}
			setFaqs(localFaqs)
		}
	}

	const saveReorderedFAQs = () => {
		faqs?.map( async (faq, index) => {
			const faqData = {
				question: faq?.question,
				answer: faq?.answer,
				position: index + 1
			}
			await updateFAQ(faqData, faq.faq_id);
		})
		Swal.fire({
			icon: 'success',
			title: 'Sucesso!',
			text: 'Reordenação salva com sucesso!',
		})
		setEditFaq(false)
	}

	const contentsToBeShown = useMemo(() => {
		return faqs && faqs.length
			? faqs.map((faq: any, index) => ({
					question: faq.question,
					date: formatDate(faq?.created_at),
					actions: (
						<>
							<DefaultButton
								className="small info"
								title="Editar FAQ"
								onClick={() => editFAQS(faq.faq_id)}
							>
								<BiEdit />
							</DefaultButton>{' '}
							<DefaultButton
								className="small danger"
								title="Deletar FAQ"
								onClick={() => deleteFAQ(faq.faq_id)}
							>
								<BiTrash />
							</DefaultButton>{' '}
							{index > 0 ? (
								<DefaultButton type="button"
									title="Subir Faq"
									className="small white up"
									onClick={() => reorderFAQs(faq, true)}>
										<AiOutlineUp/>
								</DefaultButton>
								): (<></>)
							} {' '}
							{index < faqs.length - 1 ? (
							<DefaultButton type="button"
								title="Descer Faq"
								className="small white down"
								onClick={() => reorderFAQs(faq, false)}>
								<AiOutlineDown/>
							</DefaultButton>) :(<></>)}

						</>
					),
			  }))
			: []
	}, [deleteFAQ, faqs, editFAQS])

	return (
		<FAQContainer>
			<BreadCrumb crumbs={[<Link to="/profile">Perfil</Link>, <span>FAQ's</span>]} />

			<DefaultPageTitle>FAQ's</DefaultPageTitle>

			<CreateButtonDefaultContainer>
				<DefaultButton onClick={createFAQS}>Criar FAQ'S</DefaultButton>
					&nbsp;
					&nbsp;
				{editFaq && <DefaultButton onClick={saveReorderedFAQs} className="success">Salvar Reordenação das FAQ'S</DefaultButton>}
			</CreateButtonDefaultContainer>
			<CreateButtonDefaultContainer>

			</CreateButtonDefaultContainer>

			<DefaultTable
				usePagination={false}
				headersConfig={[
					{
						headerLabel: <span>Pergunta</span>,
						propName: 'question',
					},
					{
						headerLabel: <span>Data de Criação</span>,
						propName: 'date',
					},
					{
						headerLabel: <span>Ações</span>,
						propName: 'actions',
					},
				]}
				items={contentsToBeShown}
				emptyListMessage={'Não foram encontrados FAQS cadastradas!'}
			/>
		</FAQContainer>
	)
}

export default FAQS
